/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class ServiceTypePop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      serviceType: this.props.serviceType,
      style: null,
      serviceTypeList: [
        {type: '토즈 스터디센터', text: '토즈 스터디센터'},
        {type: '토즈 모임&워크센터', text: '토즈 모임&워크센터'}
      ]
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) });
  }

  _doChangeServiceTypeEvent = (e) => {
    this.setState({ serviceType: e.target.dataset.servicetype });
    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  render() {
    return (
      <div className="layer-pop" id="service-pop" style={this.state.style} ref={ref => this.layer = ref}>	
	      <div className="bg" data-servicetype={this.state.serviceType} data-type="serviceType" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <ul className="sel-list-pop">
          {this.state.serviceTypeList.map((entity, index) => <li key={index} className={this.state.serviceType === entity.type ? 'active' : ''}><a href={null} data-servicetype={entity.type} onClick={this._doChangeServiceTypeEvent.bind(this)}>{entity.text}</a></li>)}
        </ul>
      </div>
    )
  }
}

export default ServiceTypePop;